import { NoIntegrationsPlaceholder } from 'components/integrations/NoIntegrationsPlaceholder';
import { ProviderDetails } from 'components/integrations/ProviderDetails';
import { LoadingSpinner } from 'components/ui';
import { useGetStoreInfoQuery } from 'store/services/segmentsApi';
import { useParseURLQueryParams } from 'utils';

export const MyIntegrations = () => {
  const { rawQueryParams, serializedStoreName } = useParseURLQueryParams();

  const { data: storeInfo, isFetching } = useGetStoreInfoQuery(
    String(serializedStoreName),
    {
      skip: !!!rawQueryParams?.store_name,
    }
  );

  const connectedProviders = storeInfo?.integrations.map(
    (item) => item.provider
  );

  return (
    <section>
      <p className="mt-4 font-bold leading-10 text-segments-44px">
        Active connections
      </p>

      <p className="mt-6 text-base">
        Integrations are how Segments connects with your marketing channels so
        you can easily sync your favorite customer segments and build
        long-lasting customer relationships.
        <br />
        <br />
        For example, integrate with social platforms or email marketing apps and
        sync your segments as custom audiences.
      </p>

      <div className="mt-10">
        {isFetching ? (
          <div className="flex justify-center mt-28 mb-28">
            <LoadingSpinner className="w-20 h-20 text-segments-accent-color-orange" />
          </div>
        ) : !!!connectedProviders?.length ? (
          <NoIntegrationsPlaceholder />
        ) : (
          <div className="flex flex-wrap gap-6 mt-4 ">
            {connectedProviders?.map((provider) => (
              <div key={provider}>
                <ProviderDetails provider={provider} />
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
